export enum BlockTypes {
  BlockSurvey = 'BlockSurvey',
  BlockRichText = 'BlockRichText',
  BlockTask = 'BlockTask',
  BlockMultimedia = 'BlockMultimedia',
  BlockEvaluation = 'BlockEvaluation',
  BlockScorm = 'BlockScorm',
  BlockMeeting = 'BlockMeeting',
  BlockSession = 'BlockSession',
  // V2 - This is the new block type for evaluation
  Evaluation = 'Evaluation',
}
